import { render } from "./SelectOrderView.vue?vue&type=template&id=79fa9d36"
import script from "./SelectOrderView.vue?vue&type=script&lang=js"
export * from "./SelectOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__